import { render, staticRenderFns } from "./DropdownContent.vue?vue&type=template&id=6b2ab80e"
import script from "./DropdownContent.vue?vue&type=script&lang=ts"
export * from "./DropdownContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports